import {
  FETCHING_INTEGRATIONS_REQUEST,
  FETCHING_INTEGRATIONS_SUCCEDDED,
  FETCHING_INTEGRATIONS_FAILED,
  INVALIDATE_INTEGRATIONS,
  ACTIVATING_INTEGRATION_SUCCEDDED,
  SYNCHRONISING_INTEGRATION_SUCCEDDED,
  INTEGRATION_AUTH_EXPIRED,
  FETCHING_INTEGRATION_SUCCEDDED,
  DEACTIVATING_INTEGRATION_FAILED,
  DEACTIVATING_INTEGRATION_REQUEST,
  DEACTIVATING_INTEGRATION_SUCCEDDED,
  FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
  FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEDDED,
  FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
  FETCHING_INTEGRATION_CUSTOM_FIELDS_REQUEST,
  FETCHING_INTEGRATION_CUSTOM_FIELDS_FAILED,
  FETCHING_INTEGRATION_CUSTOM_FIELDS_SUCCEDDED,
  SAVING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
  SAVING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED,
  SAVING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
  SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST,
  SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED,
  SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED,
  DELETING_INTEGRATION_CUSTOM_FIELDS_REQUEST,
  DELETING_INTEGRATION_CUSTOM_FIELDS_SUCCEEDED,
  DELETING_INTEGRATION_CUSTOM_FIELDS_FAILED,
  FETCHING_CRM_ENABLED_INTEGRATION_REQUEST,
  FETCHING_CRM_ENABLED_INTEGRATION_SUCCEEDED,
  FETCHING_CRM_ENABLED_INTEGRATION_FAILED,
  // UPDATING_PRIMARY_CONFIGURATION_SUCCEEDED
} from "../actions/actionTypes.jsx";

import { freshsalesReducer } from "./integrations/freshsalesReducer";
import { suitecrmReducer } from "./integrations/suitecrmReducer";
import { intercomReducer } from "./integrations/intercomReducer";
import { hubspotReducer } from "./integrations/hubspotReducer";
import { salesforceReducer } from "./integrations/salesforceReducer";
import { salesforceSandboxReducer } from "./integrations/salesforceSandboxReducer";
import { combineReducers } from "redux";
import { chatIntegrationReducer } from "./integrations/chatIntegrationReducer";
import { emailIntegrationReducer } from "./integrations/emailIntegrationReducer";
import { eloquaReducer } from "./integrations/eloquaReducer";
import { pipedriveReducer } from "./integrations/pipedriveReducer";
import { klentyReducer } from "./integrations/klentyReducer";
import { googleAnalyticsReducer } from "./integrations/googleAnalyticsReducer";
import { googleAnalytics4Reducer } from "./integrations/googleAnalytics4Reducer";
import { googleTagManagerReducer } from "./integrations/googleTagManagerReducer";
import { sixSenseReducer } from "./integrations/sixSenseReducer";
import { smtpReducer } from "./integrations/smtpReducer";
import { zohoReducer } from "./integrations/zohoReducer";
import { outreachReducer } from "./integrations/outreachReducer";
import { msDynamicsReducer } from "./integrations/msDynamicsReducer";
import { webinrIntegrationReducer } from "./integrations/webinrIntegrationReducer";
import { salesloftReducer } from "./integrations/salesloftReducer";
import { allocadiaIntegrationReducer } from "./integrations/allocadiaIntegrationReducer";
import { marketoReducer } from "./integrations/marketoReducer";
import { zoomReducer } from "./integrations/zoomReducer";
import { teamsReducer } from "./integrations/teamsReducer";
import { externalScriptReducer } from "./integrations/externalIntegrationReducer";
import { pardotReducer } from "./integrations/pardotReducer";
import { netsuiteReducer } from  "./integrations/netsuiteReducer";
import { cleverstoryReducer } from "./integrations/cleverstoryReducer.jsx";
import _ from "lodash";
import { fireFliesReducer } from "./integrations/firefliesReducer.jsx";
// import {UPDATING_PRIMARY_CONFIGURATION, UPDATING_PRIMARY_CONFIGURATION_FAILED } from "../actions/actionTypes";

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  deactivating: {
    loading: false,
    errors: null,
  },
  opportunityFields: {
    loading: false,
    items: [],
    errors: null,
  },
  customFields: {
    loading: false,
    items: [],
    errors: null,
  },
  crmIntegration: {
    loading: false,
    item: null,
    errors: null,
  },
};

function activatedIntegrationsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_INTEGRATIONS_REQUEST:
      {return Object.assign({}, state, {
        loading: true,
        invalidated: true,
        loaded: false
      });}
    case FETCHING_INTEGRATIONS_SUCCEDDED:
     { return Object.assign({}, state, {
        loading: false,
        invalidated: false,
        loaded: true,
        items: action.payload,
      });}
    case FETCHING_INTEGRATIONS_FAILED:
      {return Object.assign({}, state, {
        loading: false,
        invalidated: false,
      });}
    case INVALIDATE_INTEGRATIONS:
      {return Object.assign({}, state, {
        loading: false,
        invalidated: true,
      });}
    case ACTIVATING_INTEGRATION_SUCCEDDED: {
      let items = state.items || [];
      let integration = action.payload;

      let index = items
        .filter((item) => item != null)
        .findIndex((element) => integration.type === element.type);
    
      if (index === -1) {
        items = [...items, integration];
      } else {
        items = [
          ...items.slice(0, index),     
          integration,    
          ...items.slice(index + 1),
        ];
      }
          return {
        ...state,
        items: items,
      };
    }
    case DEACTIVATING_INTEGRATION_REQUEST:
      {return Object.assign({}, state, {
        ...state,
        deactivating: {
          loading: true,
          errors: null,
        },
      });}
    case DEACTIVATING_INTEGRATION_SUCCEDDED:
     { return Object.assign({}, state, {
        ...state,
        items: state.items.filter((integration, index) => {
          return integration.type != action.payload;
        }),
        deactivating: {
          loading: false,
          errors: null,
        },
      });}
    case DEACTIVATING_INTEGRATION_FAILED:
     { return Object.assign({}, state, {
        ...state,
        deactivating: {
          loading: false,
          errors: action.payload,
        },
      });}
    
    case SYNCHRONISING_INTEGRATION_SUCCEDDED:
     { 
      var items = state.items || [];

      var index = items.findIndex(function (element) {
        return action.payload.type == element.type;
      });

      if (index != -1) {
        let integration = items[index];
        integration = Object.assign({}, integration, {
          ...integration,
          syncStatus: action.payload.syncStatus,
        });

        items[index] = integration;
      }

      return Object.assign({}, state, {
        ...state,
        items: items,
      });
    }

    case INTEGRATION_AUTH_EXPIRED:
    {  var items = state.items || [];

      var error = _.get(action.payload,'state[0]');

      if (!error || error.code !== 23002) {
        return state;
      }

      var index = items.findIndex(function (element) {
        return action.payload.type == element.type;
      });

      if (index != -1) {
        let integration = items[index];
        integration = Object.assign({}, integration, {
          ...integration,
          state: error.state,
        });

        items[index] = integration;
      }

      return Object.assign({}, state, {
        ...state,
        items: items,
      });}
    case FETCHING_INTEGRATION_SUCCEDDED:
     { var items = state.items || [];

      var index = items.findIndex(function (element) {
        return action.payload.type == element.type;
      });

      if (index != -1) {
        items[index] = action.payload;
      } else {
        items.push(action.payload);
      }

      return Object.assign({}, state, {
        ...state,
        items: items,
      });}
    case FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST:
     { return Object.assign({
        ...state,
        opportunityFields: { ...state.opportunityFields, loading: true },
      });}
    case FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEDDED:
     { return Object.assign({
        ...state,
        opportunityFields: {
          loading: false,
          items: action.payload,
          errors: null,
        },
      });}
    case FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED:
    {  return Object.assign({
        ...state,
        opportunityFields: {
          loading: false,
          items: [],
          errors: action.payload,
        },
      });}
    case FETCHING_INTEGRATION_CUSTOM_FIELDS_REQUEST:
     { return Object.assign({
        ...state,
        customFields: { ...state.customFields, loading: true },
      });}
    case FETCHING_INTEGRATION_CUSTOM_FIELDS_SUCCEDDED:
      {return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: action.payload,
          errors: null,
        },
      });}
    case FETCHING_INTEGRATION_CUSTOM_FIELDS_FAILED:
      {return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: [],
          errors: action.payload,
        },
      });}
    case SAVING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST:
     { return Object.assign({
        ...state,
        customFields: { ...state.customFields, loading: true },
      });}
    case SAVING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED:
     { return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: action.payload,
          errors: null,
        },
      });}
    case SAVING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED:
     { return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: [],
          errors: action.payload,
        },
      });}
    case SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST:
      {return Object.assign({
        ...state,
        customFields: { ...state.customFields, loading: true },
      });}
    case SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED:
      {return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: action.payload,
          errors: null,
        },
      });}
    case SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED:
      {return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: [],
          errors: action.payload,
        },
      });}
    case DELETING_INTEGRATION_CUSTOM_FIELDS_REQUEST:
      {return Object.assign({
        ...state,
        customFields: { ...state.customFields, loading: true },
      });}
    case DELETING_INTEGRATION_CUSTOM_FIELDS_SUCCEEDED:
     { return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: action.payload,
          errors: null,
        },
      });}
    case DELETING_INTEGRATION_CUSTOM_FIELDS_FAILED:
      {return Object.assign({
        ...state,
        customFields: {
          loading: false,
          items: [],
          errors: action.payload,
        },
      });}
    case FETCHING_CRM_ENABLED_INTEGRATION_REQUEST:
      {return Object.assign({}, state, {
        ...state,
        crmIntegration: {
          loading: true,
          item: null,
          errors: null,
        },
      });}
    case FETCHING_CRM_ENABLED_INTEGRATION_SUCCEEDED:
     { var result = action.payload.data;
      return Object.assign({}, state, {
        ...state,
        crmIntegration: {
          loading: false,
          item: result,
          errors: null,
        },
      });}
    case FETCHING_CRM_ENABLED_INTEGRATION_FAILED:
      {return Object.assign({}, state, {
        ...state,
        crmIntegration: {
          loading: false,
          item: null,
          errors: action.payload.errors,
        },
      });}
    // case UPDATING_PRIMARY_CONFIGURATION:
    //  { return Object.assign({}, state, {
    //     ...state,
    //     updatingPrimaryConfig: {
    //       updating: true,
    //       error: null
    //     }
    //   })}
    // case UPDATING_PRIMARY_CONFIGURATION_SUCCEEDED:
    //   {const filteredObjects = _.filter(state.items, obj => obj.type !== "salesforce_v2");
    //   return Object.assign({}, state, {
    //     ...state,
    //     items: [
    //       ...filteredObjects,
    //       action.payload
    //     ],
    //     updatingPrimaryConfig: {
    //       updating: false,
    //       error: null
    //     }
    //   });}
    // case UPDATING_PRIMARY_CONFIGURATION_FAILED:
    //  { return Object.assign({}, state, {
    //     ...state,
    //     updatingPrimaryConfig: {
    //       updating: false,
    //       error: action.payload
    //     }
    //   })}

    default:
      return state;
  }
}

const integrationsReducer = combineReducers({
  activated: activatedIntegrationsReducer,
  freshsales: freshsalesReducer,
  suitecrm: suitecrmReducer,
  intercom: intercomReducer,
  hubspot: hubspotReducer,
  salesforce: salesforceReducer,
  salesforceSandbox: salesforceSandboxReducer,
  salesloft: salesloftReducer,
  chat: chatIntegrationReducer,
  email: emailIntegrationReducer,
  eloqua: eloquaReducer,
  pipedrive: pipedriveReducer,
  klenty: klentyReducer,
  googleAnalytics: googleAnalyticsReducer,
  googleAnalytics4: googleAnalytics4Reducer,
  googleTagManager: googleTagManagerReducer,
  sixSense: sixSenseReducer,
  smtp: smtpReducer,
  zoho: zohoReducer,
  outreach: outreachReducer,
  msDynamics: msDynamicsReducer,
  webinr: webinrIntegrationReducer,
  allocadia: allocadiaIntegrationReducer,
  marketo: marketoReducer,
  zoom: zoomReducer,
  teams: teamsReducer,
  externalScript: externalScriptReducer,
  pardot: pardotReducer,
  netsuite: netsuiteReducer,
  cleverstory: cleverstoryReducer,
  fireflies: fireFliesReducer
});

export { integrationsReducer };
